import {connect} from "react-redux";
import CompleteBaOpportunity from "./edit";
import {bindActionCreators} from "redux";
import {dropdownData} from "../../../../service/Account/action";
import {getOpportunity, updateOpportunity} from "../../../../service/Opportunities/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    updateOpportunityDetails:state.Opportunitie.updateOpportunityDetails,
    opportunityDetails:state.Opportunitie.opportunityDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            getOpportunity,
            updateOpportunity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteBaOpportunity);
